module.exports = __webpack_public_path__ + "static/media/1 shark tattoo deepsea ocean black and grey sleeve tattoo.1280x1707.c470d0b8.webp";